import { adaptSubscription } from './adaptSubscription';

export const adaptTenantSubscriptions = (response) => {
  return (
    response?.response?.map((_subscription) => {
      return adaptSubscription(_subscription);
    }) || []
  );
};
